export const getPercentage = (value: number, total: number): string => {
  if (total === 0) return "(0%)"
  const percentage = (value / total) * 100

  if (percentage % 1 === 0) {
    return `(${percentage}%)`
  }
  return `(${percentage.toFixed(1)}%)`
}
